<template>
  <div class="white-box position-relative">
    <TileLoader :loading="loading"/>
    <div class="header-container">
      <h2>Surveillance financière</h2>
      <div>
        <a target="_blank"
           rel="noreferrer"
           :href="getIntraRedirectUrl('/Pages/Adherent/SupplierMonitoring.aspx')"
        >
          <button class="btn-cmem">Voir la liste complète</button>
        </a>
      </div>
    </div>
    <div class="table-container mt-2">
      <table class="datas-table">
        <thead>
        <tr>
          <th>Fournisseur</th>
          <th class="number">Score</th>
          <th>Commentaire</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, i) of sortedDatas.slice(0, 5)" :key="row.Guid + i">
          <router-link :to="{path: '/dashboard-cdm/rdv', query: {frsGuid: row.Guid}}">
            {{ row.Name }}
          </router-link>
          <td class="number">{{ row.Score }}</td>
          <td>{{ row.Comment }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
import TileLoader from "./TileLoader.vue";
import {getEllisphereAlerts} from "@/utils/dashboardCdm";
import store from "@/store/dashboards";
import {getDroneRedirectUrl, getIntraRedirectUrl} from "@/helpers/getRedirectUrlHelper";

export default {
  components: {TileLoader},
  name: 'EllisphereAlertsTile',
  data() {
    return {
      loading: 0,
      datas: [],
      store
    }
  },
  watch: {
    storeGlobalView() {
      this.initData();
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    getIntraRedirectUrl,
    getDroneRedirectUrl,
    initData() {
      this.loading = 1;
      getEllisphereAlerts(this.storeGlobalView).then(res => {
        if (res.length)
          this.datas = res;
        this.loading = 0;
      })
    },
    formatEuro(value, precision = 2) {
      return Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: precision
      }).format(value);
    },
  },
  computed: {
    storeGlobalView() {
      return this.store.globalView;
    },
    sortedDatas() {
      return [...this.datas].sort((a, b) => b[this.sortedBy] - a[this.sortedBy]);
    }
  }
}
</script>

<style scoped>
.white-box {
  flex: 1 1 25em;
  padding: 12px;

  display: flex;
  flex-direction: column;
}

.header-container {
  display: flex;
  justify-content: space-between;
  column-gap: 12px;
}

h2 {
  display: flex;
  align-items: center;

  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

.btns-container {
  display: flex;
  gap: 12px;
  margin: 12px 0;
}

.btns-container button:not(.active) {
  background-color: white;
}

p {
  margin: 0;
}

.table-container {
  max-height: 23em;
  overflow: auto;
}

.datas-table thead {
  border-bottom: 1px solid black;
}

.datas-table th, .datas-table td {
  padding: 2px 8px;
}

.datas-table tbody tr:nth-child(odd) {
  background-color: #EFEFEF;
}

.datas-table tbody tr:nth-child(even) {
  background-color: #C5C5C5;
}

.datas-table a {
  color: inherit;
  text-decoration: none;
}

.datas-table td.with-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
}

.datas-table .number {
  text-align: right;
  vertical-align: baseline;
}

.datas-table .tag > div {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.datas-table .tag > div.green {
  background-color: #388E3C;
}

.datas-table .tag > div.orange {
  background-color: #FFC107;
}

.datas-table .tag > div.red {
  background-color: #D32F2F;
}

.trend-indicator {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  font-size: 0.8em;
}

.trend-indicator.up {
  color: #388E3C;
}

.trend-indicator.up::before {
  content: url('data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20fill%3D%22none%22%20stroke%3D%22%23388E3C%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%3E%3Cpath%20d%3D%22m3%2017l6-6l4%204l8-8%22%2F%3E%3Cpath%20d%3D%22M17%207h4v4%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
}

.trend-indicator.down {
  color: #D32F2F;
}

.trend-indicator.down::before {
  content: url('data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20fill%3D%22none%22%20stroke%3D%22%23D32F2F%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%3E%3Cpath%20d%3D%22m3%207l6%206l4-4l8%208%22%2F%3E%3Cpath%20d%3D%22M17%2017h4v-4%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboards/EllisphereAlertsTile.vue